import { API_IDS } from '@intigral/constant';
import { IHttpAdapter } from '../../entity/interface/iHttpAdapter';
import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../DataDomain';
import { IApiPathManager } from '../config/ApiPathManager';
import { ICustomConfigurationRepository } from '../../core/repositories/interfaces/iCustomConfigurationRepository';
import { IGetProvidersResponse } from '../../entity/interface/iGetProviders';
import { IGetFooterMenuResponse } from '../../entity/interface/iGetFooterMenu';
import { IGetHeaderMenuResponse } from '../../entity/interface/IGetHeaderMenu';
import { IBigScreenCmsMoodsResponse, IBigScreenCmsGamesResponse } from '../../entity/interface/iBigScreenCmsMoods';
import { IProfileAvatarsResponse } from '../../entity/interface/iProfile';

class CustomConfigurationRepository implements ICustomConfigurationRepository {
    // Lazy getters for dependencies to avoid circular dependencies
    private get http(): IHttpAdapter {
        return container.resolve<IHttpAdapter>(DI.UTILS.IHttpAdapter);
    }

    private get apiPathManager(): IApiPathManager {
        return container.resolve<IApiPathManager>(DI.UTILS.IApiPathManager);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async getProfileAvatars(): Promise<IProfileAvatarsResponse> {
        const response = await this.http.get<IProfileAvatarsResponse>(
            this.apiPathManager.getPath(API_IDS.PROFILE_AVATER_LIST),
            {}
        );
        return response.data;
    }

    async getProviders(dataSources: string): Promise<IGetProvidersResponse> {
        const response = await this.http.get<IGetProvidersResponse>(
            this.apiPathManager.getByDatasource(dataSources),
            {}
        );
        return response.data;
    }

    async getFooterMenuContent(): Promise<IGetFooterMenuResponse> {
        const response = await this.http.get<IGetFooterMenuResponse>(
            this.apiPathManager.getPath(API_IDS.GET_FOOTER_MENU_CONTENT),
            {}
        );
        return response.data;
    }

    async getHeaderMenuContent(): Promise<IGetHeaderMenuResponse> {
        const response = await this.http.get<IGetHeaderMenuResponse>(
            this.apiPathManager.getPath(API_IDS.GET_HEADER_MENU_CONTENT),
            {}
        );
        return response.data;
    }

    async getMoods(): Promise<IBigScreenCmsMoodsResponse> {
        const response = await this.http.get<IBigScreenCmsMoodsResponse>(
            this.apiPathManager.getPath(API_IDS.MOODS_RECOMMENDATION),
            {}
        );
        return response.data;
    }

    async getGames(): Promise<IBigScreenCmsGamesResponse> {
        const response = await this.http.get<IBigScreenCmsGamesResponse>(
            this.apiPathManager.getPath(API_IDS.STC_PLAY_GAMES),
            {}
        );
        return response.data;
    }
}

export default CustomConfigurationRepository;
